// Spanish for the warehouse inventory (src/inventory). English text (exact) -> Spanish.
const dict = {
  // ---- page / tabs ----
  "Warehouse": "Almacén",
  "Supplies to order": "Materiales por pedir",
  "Old warehouse list": "Lista anterior del almacén",
  "Find items": "Buscar artículos",
  "Shelves": "Estantes",
  "Shelves & labels": "Estantes y etiquetas",
  "Scan / put away": "Escanear / guardar",
  "Add item": "Agregar artículo",
  "{n} items": "{n} artículos",
  "{n} low": "{n} bajos",
  "{n} not on a shelf": "{n} sin estante",

  // ---- search ----
  "Search: 3/4 pvc elbow, romex, caulk, B-2-3…": "Buscar: codo pvc 3/4, romex, sellador, B-2-3…",
  "Search the warehouse": "Buscar en el almacén",
  "Search items": "Buscar artículos",
  "Scan": "Escanear",
  "All": "Todo",
  "Low stock": "Poco inventario",
  "Not on a shelf": "Sin estante",
  "Showing shelf": "Mostrando estante",
  "Put away here": "Guardar aquí",
  "Clear": "Quitar",
  "Clear filters": "Quitar filtros",
  "{n} results": "{n} resultados",
  "Out of stock": "Agotado",
  "Low": "Bajo",
  "No shelf": "Sin estante",
  "Nothing matches \"{q}\".": "Nada coincide con \"{q}\".",
  "No items yet.": "Todavía no hay artículos.",
  "Show more ({n} left)": "Ver más (quedan {n})",
  "The warehouse didn't load. Check your connection.": "El almacén no cargó. Revise su conexión.",

  // ---- item detail ----
  "on hand": "disponibles",
  "{n} on hand": "{n} disponibles",
  "Low – reorder at {n}": "Bajo – pedir más al llegar a {n}",
  "Cost each": "Costo c/u",
  "Where it is": "Dónde está",
  "None in stock.": "No hay en inventario.",
  "Not on a shelf yet": "Todavía sin estante",
  "Take": "Sacar",
  "Put away": "Guardar",
  "Move": "Mover",
  "Count": "Contar",
  "Barcodes": "Códigos de barras",
  "No barcode. Print a sticker so it can be scanned.": "Sin código de barras. Imprima una etiqueta para poder escanearlo.",
  "History": "Historial",
  "No changes yet.": "Todavía no hay cambios.",
  "Put away {qty} on {to}": "Guardó {qty} en {to}",
  "Took {qty} from {from}": "Sacó {qty} de {from}",
  "Moved {qty} from {from} to {to}": "Movió {qty} de {from} a {to}",
  "Counted {to}: {before} → {after}": "Contó {to}: {before} → {after}",
  "Print sticker": "Imprimir etiqueta",
  "Delete {name}? Its history is kept.": "¿Eliminar {name}? Su historial se conserva.",

  // ---- item editor ----
  "New item": "Artículo nuevo",
  "Edit item": "Editar artículo",
  "No photo yet": "Sin foto",
  "Take photo": "Tomar foto",
  "Retake photo": "Tomar otra foto",
  "Name": "Nombre",
  "e.g. 3/4 in PVC 90 elbow": "ej. codo PVC 90 de 3/4 in",
  "Category": "Categoría",
  "Pick one": "Elija una",
  "Unit": "Unidad",
  "Brand": "Marca",
  "Model / SKU": "Modelo / SKU",
  "None yet": "Ninguno todavía",
  "Type barcode numbers": "Escriba los números del código",
  "Add": "Agregar",
  "Remove": "Quitar",
  "Shelf": "Estante",
  "Quantity": "Cantidad",
  "Reorder when at or below": "Pedir más al llegar a",
  "Cost each ($)": "Costo c/u ($)",
  "Description / notes": "Descripción / notas",
  "Save item": "Guardar artículo",
  "Save changes": "Guardar cambios",
  "Give the item a name.": "Póngale un nombre al artículo.",
  "Pick a category.": "Elija una categoría.",
  "That shelf code doesn't look right. Use the format B-2-3.": "Ese código de estante no está bien. Use el formato B-2-3.",
  "Could not save. Check your connection and try again.": "No se pudo guardar. Revise su conexión e intente de nuevo.",
  "Scan the shelf label": "Escanee la etiqueta del estante",
  "Scan the product barcode": "Escanee el código de barras del producto",
  "That wasn't a shelf label.": "Eso no era una etiqueta de estante.",
  "That was a shelf label or item sticker, not a product barcode.": "Eso era una etiqueta de estante o de artículo, no un código de producto.",

  // ---- scanner ----
  "Scan a barcode": "Escanear un código",
  "Starting camera…": "Abriendo la cámara…",
  "Use": "Usar",
  "Or type the code (e.g. B-2-3 or the numbers under the barcode)": "O escriba el código (ej. B-2-3 o los números debajo del código de barras)",
  "This browser can't use the camera. Type the code below instead.": "Este navegador no puede usar la cámara. Escriba el código abajo.",
  "Camera access is blocked. Allow the camera for this site in your phone's settings, or type the code below.": "El acceso a la cámara está bloqueado. Permita la cámara para este sitio en la configuración del teléfono, o escriba el código abajo.",
  "No camera found on this device. Type the code below instead.": "No se encontró una cámara. Escriba el código abajo.",
  "The camera couldn't start. Type the code below instead.": "La cámara no pudo abrir. Escriba el código abajo.",
  "Scan to find": "Escanear para buscar",
  "Shelf label, item sticker, or product barcode": "Etiqueta de estante, etiqueta de artículo o código de producto",

  // ---- scan station ----
  "Done": "Listo",
  "Scan shelf or item": "Escanear estante o artículo",
  "Or type a shelf code": "O escriba un código de estante",
  "Now scan the shelf it's going TO": "Ahora escanee el estante DESTINO",
  "Item": "Artículo",
  "Change": "Cambiar",
  "From shelf": "Del estante",
  "To shelf": "Al estante",
  "Take from": "Sacar de",
  "{n} here": "{n} aquí",
  "{n} on {shelf}": "{n} en {shelf}",
  "This item has no stock anywhere.": "Este artículo no tiene inventario en ningún lado.",
  "New barcode": "Código nuevo",
  "This product isn't in the system yet.": "Este producto todavía no está en el sistema.",
  "Add new item": "Agregar artículo nuevo",
  "Or add this barcode to an item we already have:": "O agregue este código a un artículo que ya tenemos:",
  "Scan the item, or search for it:": "Escanee el artículo, o búsquelo:",
  "Exact count on this shelf": "Cantidad exacta en este estante",
  "For which job / note (optional)": "Para qué trabajo / nota (opcional)",
  "Note (optional)": "Nota (opcional)",
  "Save – put away": "Guardar – guardar en estante",
  "Save – take": "Guardar – sacar",
  "Save – move": "Guardar – mover",
  "Save count": "Guardar conteo",
  "Item saved. Enter the quantity and save.": "Artículo guardado. Escriba la cantidad y guarde.",
  "That item sticker isn't in the system anymore.": "Esa etiqueta de artículo ya no está en el sistema.",
  "{code} isn't in the shelf layout, but it will still work.": "{code} no está en el plano de estantes, pero igual funciona.",
  "Put away {qty} × {name} on {shelf}. Now {after} there.": "Guardó {qty} × {name} en {shelf}. Ahora hay {after} ahí.",
  "{name} on {shelf} counted: {after}.": "{name} en {shelf} contado: {after}.",
  "Took {qty} × {name} from {shelf}. {total} left in total.": "Sacó {qty} × {name} de {shelf}. Quedan {total} en total.",
  "Moved {qty} × {name} from {from} to {to}.": "Movió {qty} × {name} de {from} a {to}.",

  // ---- stock errors (inventoryUtils) ----
  "Count can't be below zero.": "El conteo no puede ser menor que cero.",
  "Pick a shelf.": "Elija un estante.",
  "Enter a quantity above zero.": "Escriba una cantidad mayor que cero.",
  "Pick where it's coming from.": "Elija de dónde sale.",
  "Only {n} not on a shelf.": "Solo hay {n} sin estante.",
  "Only {n} on {shelf}.": "Solo hay {n} en {shelf}.",
  "Pick the shelf it's going to.": "Elija el estante destino.",
  "That's the same shelf.": "Es el mismo estante.",
  "Unknown stock change.": "Cambio de inventario desconocido.",
  "That item no longer exists.": "Ese artículo ya no existe.",

  // ---- shelves & labels ----
  "Shelf map": "Mapa de estantes",
  "{n} shelves": "{n} estantes",
  "{n} items not on a shelf yet": "{n} artículos todavía sin estante",
  "Each box is one shelf. The number is how many different items are on it. Tap a shelf to see them.": "Cada cuadro es un estante. El número es cuántos artículos distintos tiene. Toque un estante para verlos.",
  "Unit {n}": "Unidad {n}",
  "Print labels": "Imprimir etiquetas",
  "Shelf labels print 10 per sheet on 2\" x 4\" labels (Avery 5163). Item stickers print 30 per sheet (Avery 5160). Plain paper works too.": "Las etiquetas de estante salen 10 por hoja en etiquetas de 2\" x 4\" (Avery 5163). Las de artículo salen 30 por hoja (Avery 5160). También sirve papel normal.",
  "All rows": "Todas las filas",
  "Row {row}": "Fila {row}",
  "Print shelf labels ({n})": "Imprimir etiquetas de estante ({n})",
  "Print row signs": "Imprimir letreros de fila",
  "Item stickers for items with no barcode ({n})": "Etiquetas para artículos sin código ({n})",
  "Warehouse layout": "Plano del almacén",
  "Area name": "Nombre del área",
  "Row": "Fila",
  "Units (4 ft wide)": "Unidades (4 pies de ancho)",
  "Shelves per unit": "Repisas por unidad",
  "Changing the layout doesn't move any stock. Items on a shelf you remove keep showing that code until they're moved.": "Cambiar el plano no mueve el inventario. Los artículos en un estante que quite siguen mostrando ese código hasta que se muevan.",
  "Add row": "Agregar fila",
  "Save layout": "Guardar plano",
  "Layout saved.": "Plano guardado.",
  "Each row needs a letter (A, B, C…).": "Cada fila necesita una letra (A, B, C…).",
  "Two rows have the same letter.": "Dos filas tienen la misma letra.",
  "Copies every item from the old Warehouse Supplies table into this warehouse. Their quantities go to \"Not on a shelf yet\" until someone scans them onto a shelf. The old spot is kept in the notes.": "Copia cada artículo de la tabla anterior al almacén nuevo. Sus cantidades quedan en \"Todavía sin estante\" hasta que alguien las escanee a un estante. La ubicación anterior queda en las notas.",
  "Copy old list into the warehouse": "Copiar la lista anterior al almacén",
  "Copying…": "Copiando…",
  "Copy the old Warehouse Supplies list into the new warehouse? The old list is not changed, and items already copied are skipped.": "¿Copiar la lista anterior al almacén nuevo? La lista anterior no se cambia, y los artículos ya copiados se omiten.",
  "Copied {created} items. {skipped} were already here.": "Se copiaron {created} artículos. {skipped} ya estaban.",
  "Your browser blocked the print window. Allow pop-ups for this site and try again.": "El navegador bloqueó la ventana de impresión. Permita ventanas emergentes para este sitio e intente de nuevo.",

  // ---- categories (stored in English, shown in Spanish) ----
  "Plumbing Supplies": "Plomería",
  "Electrical Supplies": "Electricidad",
  "Fasteners & Hardware": "Tornillería y ferretería",
  "Hand Tools": "Herramientas manuales",
  "Power Tools": "Herramientas eléctricas",
  "Paint & Finishing Supplies": "Pintura y acabados",
  "Adhesives & Sealants": "Adhesivos y selladores",
  "Lumber & Wood Supplies": "Madera",
  "Drywall & Framing": "Tablaroca y estructura",
  "Concrete & Masonry Supplies": "Concreto y albañilería",
  "Roofing & Insulation": "Techos y aislamiento",
  "HVAC & Ventilation": "Aire acondicionado y ventilación",
  "Metal & Structural Materials": "Metal y materiales estructurales",
  "Safety Equipment": "Equipo de seguridad",
  "Ladders & Scaffolding": "Escaleras y andamios",
  "Measuring & Layout Tools": "Medición y trazo",
  "Demolition & Cleanup Supplies": "Demolición y limpieza",
  "Pest Control Supplies": "Control de plagas",
  "Janitorial & Cleaning": "Conserjería y limpieza",
  "Site Equipment": "Equipo de obra",
  "Temporary Structures": "Estructuras temporales",
  "Heavy Equipment & Machinery": "Maquinaria pesada",
  "Miscellaneous Supplies": "Varios",

  // ---- units ----
  "Each": "Pieza",
  "Box": "Caja",
  "Bag": "Bolsa",
  "Roll": "Rollo",
  "Gallon": "Galón",
  "Case": "Caja grande",
  "Pack": "Paquete",
  "Sheet": "Hoja",
  "Foot": "Pie",
  "Pair": "Par",
  "Tube": "Tubo",
  "Bucket": "Cubeta",
};

export default dict;
